require('./app');

Vue.component('s-stepper', require('./components/frontend/Stepper.vue').default);
Vue.component('button-next', require('./components/frontend/ButtonNext.vue').default);
Vue.component('button-previous', require('./components/frontend/ButtonPrevious.vue').default);
Vue.component('contact-dialog', require('./components/frontend/ContactDialog.vue').default);
Vue.component('intro-dialog', require('./components/frontend/IntroDialog.vue').default);
Vue.component('repeat-dialog', require('./components/frontend/RepeatDialog.vue').default);
Vue.component('continue-dialog', require('./components/frontend/ContinueDialog.vue').default);

Vue.component('s-traveling-expense-field', require('./components/frontend/TravelingExpenseField.vue').default);
Vue.component('s-misc-traveling-expense-field', require('./components/frontend/MiscTravelingExpenseField.vue').default);
Vue.component('s-performance-date-field', require('./components/frontend/PerformanceDateField.vue').default);

Vue.component('summary-table', require('./components/frontend/SummaryTable.vue').default);

Vue.component('address-step', require('./components/frontend/AddressStep.vue').default);
Vue.component('event-step', require('./components/frontend/EventStep.vue').default);
Vue.component('invoice-step', require('./components/frontend/InvoiceStep.vue').default);
Vue.component('bank-account-step', require('./components/frontend/BankAccountStep.vue').default);
Vue.component('tax-step', require('./components/frontend/TaxStep.vue').default);
Vue.component('royalty-step', require('./components/frontend/RoyaltyStep.vue').default);
Vue.component('traveling-expenses-step', require('./components/frontend/TravelingExpensesStep.vue').default);
Vue.component('sum-step', require('./components/frontend/SumStep.vue').default);
Vue.component('upload-step', require('./components/frontend/UploadStep.vue').default);
Vue.component('summary-step', require('./components/frontend/SummaryStep.vue').default);

Vue.component('success', require('./components/frontend/Success.vue').default);

Vue.component('s-footer', require('./components/Footer.vue').default);
Vue.component('s-legal-notice', require('./components/LegalNotice.vue').default);
Vue.component('s-terms', require('./components/Terms.vue').default);
Vue.component('s-privacy-policy', require('./components/PrivacyPolicy.vue').default);


const store = new Vuex.Store({
    state:{
        terms: false,
        legalNotice: false,
        privacyPolicy: false,
    },
    mutations: {
        setTerms(state, v) {
            state.terms = v;
        },
        setLegalNotice(state, v) {
            state.legalNotice = v;
        },
        setPrivacyPolicy(state, v) {
            state.privacyPolicy = v;
        }
    }
});

const app = new Vue({
    el: '#app',
    store,
    data: {
        csrf: '',
        drawer: true,
    }
});